var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('c-' + _vm.payload.cellType.toString().padStart(2, '0'),_vm._b({tag:"div",attrs:{"cellText":_vm.text}},'div',_vm.payload,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }